module.exports = __webpack_public_path__ + "img/donotNotice.d664b1bd.svg";